module.exports = __webpack_public_path__ + "static/media/ibanfirst-logo-small.a07ecf62.svg";